import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=132c6c4c&scoped=true&"
import script from "./ApproveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c6c4c",
  null
  
)

export default component.exports